// assets/gm-wp-list.js
(function(){
  function decodeHTML(s){
    const e = document.createElement('textarea');
    e.innerHTML = s || "";
    return e.value;
  }

  async function renderWpCards(){
    const box = document.getElementById('gm-wp-list');
    if(!box) return;

    const API = "https://blog.goods-made.com/wp-json/wp/v2/posts?per_page=6&_embed=1";
    const OPEN_NEW = true;

    try{
      const res = await fetch(API, { credentials: 'omit', mode: 'cors' });
      if(!res.ok) throw new Error("WP fetch error");
      const posts = await res.json();

      const cards = (posts || []).map(p=>{
        const link  = p.link || "#";
        const title = p?.title?.rendered ? decodeHTML(p.title.rendered) : "記事";
        const date  = p.date ? new Date(p.date).toLocaleDateString("ja-JP") : "";

        let thumb = "";
        try{
          const media = p?._embedded?.["wp:featuredmedia"]?.[0];
          thumb = media?.media_details?.sizes?.medium?.source_url || media?.source_url || "";
        }catch(e){}

        let ex = "";
        if(p?.excerpt?.rendered){
          ex = decodeHTML(p.excerpt.rendered.replace(/<[^>]*>/g, "").trim()).slice(0,80);
          if(ex.length === 80) ex += "…";
        }

        const aTarget = OPEN_NEW ? ' target="_blank" rel="noopener"' : '';

        // ▼ カード全体をクリック可能に（<a>でラップ）
        return `
          <a class="gm-card" href="${link}"${aTarget} aria-label="${title}">
            ${thumb ? `<img class="gm-thumb" src="${thumb}" alt="">` : ``}
            <div class="gm-body">
              <div class="gm-date">${date}</div>
              <h3 class="gm-title">${title}</h3>
              ${ex ? `<p class="gm-ex">${ex}</p>` : ``}
            </div>
          </a>`;
      }).join("");

      box.innerHTML = cards || "<p>記事がありません。</p>";
      box.setAttribute("aria-busy","false");
    }catch(err){
      console.error(err);
      if(box){
        box.innerHTML = "<p>ブログ記事を読み込めませんでした。</p>";
        box.setAttribute("aria-busy","false");
      }
    }
  }

  // DOM準備後に実行
  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", renderWpCards);
  }else{
    renderWpCards();
  }
})();
